export const OPTIONS_TIERS: Record<number, string[]> = {
  1: ["Covered Calls", "Cash-Secured Puts"],
  2: ["Long Calls", "Long Puts"],
  3: ["Spreads", "Covered Straddles", "Multi-leg Strategies"],
};
